import React from "react";
import { NavLink } from "react-router-dom";
import {
  Briefcase,
  Radar,
  Boxes,
  Database,
  ShieldCheck,
  Settings as SettingsIcon,
  Sparkles,
  Coins,
  Brain,
  Tag,
  Wallet,
  KeyRound,
  BookOpenCheck,
  Building2,
  FileBarChart2,
} from "lucide-react";

const links = [
  { to: "/dex", label: "Ask Dex", icon: Sparkles, testId: "nav-dex" },
  { to: "/cloud-economics", label: "Cloud Economics", icon: Wallet, testId: "nav-cloud-economics" },
  { to: "/containers", label: "Container Optimization", icon: Boxes, testId: "nav-containers" },
  { to: "/executive", label: "CFO Overview", icon: Briefcase, testId: "nav-exec-overview" },
  { to: "/opportunities", label: "Recommendations", icon: Database, testId: "nav-opportunities" },
  { to: "/governance", label: "FinOps Governance", icon: Tag, testId: "nav-governance" },
  { to: "/unit-economics", label: "Unit Economics", icon: Coins, testId: "nav-unit-economics" },
  { to: "/remediations", label: "Remediations", icon: ShieldCheck, testId: "nav-remediations" },
  { to: "/anomalies", label: "Anomaly Intelligence", icon: Radar, testId: "nav-anomalies" },
  { to: "/savings-ledger", label: "Savings Ledger", icon: BookOpenCheck, testId: "nav-savings-ledger" },
  { to: "/partnerops", label: "PartnerOps (MSP)", icon: Building2, testId: "nav-partnerops" },
  { to: "/reports", label: "Report Center", icon: FileBarChart2, testId: "nav-reports" },
  { to: "/tokenmind", label: "TokenMind", icon: Brain, testId: "nav-tokenmind" },
  { to: "/llm-config", label: "LLM Configuration", icon: KeyRound, testId: "nav-llm-config" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testId: "nav-settings" },
];

export default function Sidebar() {
  return (
    <aside
      data-testid="app-sidebar"
      className="hidden lg:flex flex-col w-64 shrink-0 border-r border-border bg-white h-screen sticky top-0"
    >
      {/* Brand */}
      <div className="px-5 py-6 border-b border-border">
        <div className="flex items-center gap-2.5">
          <img
            src="/assets/cloudscore-logo.svg"
            alt="CloudScore"
            className="h-8 w-auto"
            data-testid="cloudscore-logo"
          />
          <span className="cs-heading text-lg font-bold tracking-tight text-[#00579e]" data-testid="brand-name">
            CloudScore
          </span>
        </div>
        <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground mt-3 font-medium" data-testid="brand-tagline">
          AI FinOps Agent
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-5 space-y-0.5">
        {links.map(({ to, label, icon: Icon, testId, beta, preview }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              [
                "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-bold transition-colors duration-200",
                isActive
                  ? "bg-[#00579e] text-white"
                  : "text-muted-foreground hover:bg-[hsl(var(--cs-tint))] hover:text-foreground",
              ].join(" ")
            }
          >
            <Icon className="w-4 h-4 shrink-0" strokeWidth={2} />
            <span className="flex-1">{label}</span>
            {beta && (
              <span className="text-[9px] uppercase tracking-[0.14em] font-semibold px-1.5 py-0.5 rounded-full bg-[#48b1e4]/15 text-[#00579e]">
                Beta
              </span>
            )}
            {preview && (
              <span className="text-[9px] uppercase tracking-[0.14em] font-semibold px-1.5 py-0.5 rounded-full bg-[#6d28d9]/15 text-[#6d28d9]">
                Preview
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Status footer */}
      <div className="px-5 py-4 border-t border-border text-[11px] text-muted-foreground">
        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#22c55e] cs-pulse" />
          <span className="uppercase tracking-[0.12em] font-medium">Live</span>
        </div>
      </div>
    </aside>
  );
}
